import useAuth from "../../hooks/useAuth";
import { useEffect, useState } from "react";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import Paginator from "../exercise/components/Paginator";
import Selector from "../../components/Selector";
import ActivitiesInterface from "../activities/Activities";
import TeacherInterface from "../teacher_interface/TeacherInterface";
import Button from "../../components/Button";
import ExitButton from "../../components/ExitButton";
import Upload from "../upload/upload";
import authFetch from "../../api/authFetch";

const AccessInterface = ({successHandler}) => {
    const {setAuth} = useAuth();
    const [users, setUsers] = useState([]);
    const [requests, setRequests] = useState([]);
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [subscribed, setSubscribed] = useState(false);
    const [requestSearch, setRequestSearch] = useState("");
    const [accessPage, setAccessPage] = useState(1);
    const [requestPage, setRequestPage] = useState(1);
    const [accessPages, setAccessPages] = useState(0);
    const [requestPages, setRequestPages] = useState(0);
    const [changeList, setChangeList] = useState([]);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [teacher, setTeacher] = useState("");
    const [uploadPage, setUpload] = useState(false);
    
    const tabs = ['User management', 'User activities'];
    const options = ["USER", "TEACHER", "ADMIN"];

    const updateAccessList = async (page = 1) => {
        authFetch(`/admin/access-list?page=${page}`, {
            method: "GET"
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            if (response.status === 401) {
                localStorage.removeItem("token");
                setAuth({});
            }
        }).then(json => {
            if (json) {
                let xs = [];
                for (const user of json) {
                    xs.push(user);
                }
                setUsers(xs);
            }
        });
        await getAccessPages();
    }

    const searchRequests = async (event) => {
        event.preventDefault();
        setRequestPage(1);
        await updateRequestList();
    }

    const updateRequestList = async (page = 1) => {
        authFetch(`/admin/request-list?page=${page}${requestSearch !== "" ? `&search=${requestSearch}` : ""}`, {
            method: "GET"
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            if (response.status === 401) {
                localStorage.removeItem("token");
                setAuth({});
            }
        }).then(json => {
            if (json) {
                let xs = [];
                for (const request of json) {
                    xs.push(request);
                }
                setRequests(xs);
            }
        });
        await getRequestPages();
    }

    const changeAccess = async (username, role) => {
        const response = await authFetch(`/admin/change-access/${username}/${role}`, {
            method: "POST"
        });
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
        }
    }

    const denyAccess = async (username, role) => {
        const response = await authFetch(`/admin/deny-request/${username}/${role}`, {
            method: "POST"
        });
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
        }
    }

    const sendEmail = async (event) => {
        event.preventDefault();
        setEmail("");
        const response = await authFetch(`/admin/invite/${email}`, {
            method: "POST"
        });
        if (response.ok) {
            setEmailError("Email sendt");
        }
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
        }
        if (response.status === 409) {
            setEmailError("User with this email already exists");
        }
    }

    const handleCheck = async () => {
        setSubscribed(!subscribed);
        const response = await authFetch(`/admin/subscribe/${!subscribed}`, {
            method: "POST"
        });
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
        }
    }

    const getAccessPages = async () => {
        authFetch(`/admin/access-pages`, {
            method: "GET"
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            if (response.status === 401) {
                localStorage.removeItem("token");
                setAuth({});
            }
        }).then(json => {
            if (json) {
                setAccessPages(json.pages);
            }
        });
    }

    const getRequestPages = async () => {
        authFetch(`/admin/request-pages${requestSearch !== "" ? `?search=${requestSearch}` : ""}`, {
            method: "GET"
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            if (response.status === 401) {
                localStorage.removeItem("token");
                setAuth({});
            }
        }).then(json => {
            if (json) {
                setRequestPages(json.pages);
            }
        })
    }

    const deleteUser = async (username) => {
        const response = await authFetch(`/admin/delete-user/${username}`, {
            method: "DELETE"
        });
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
        }
    }

    const commit = async () => {
        for(const change of changeList) {
            if (change.action === "DELETE") {
                await deleteUser(change.username);
            } else if (change.action.split(" ")[0] === "DENY") {
                await denyAccess(change.username, change.action.split("->")[1]);
            } else {
                await changeAccess(change.username, change.action.split("->")[1]);
            }
        }
        setChangeList([]);
        updateAccessList();
        updateRequestList();
        getAccessPages();
        getRequestPages();
    }

    const addChange = (change) => {
        setChangeList([...changeList, change]);
    }

    const addChangeAccess = (username, oldRole, newRole) => {
        addChange({"username": username, "action": `${oldRole}->${newRole}`});        
    }

    const addDenyAccess = (username, oldRole, newRole) => {
        addChange({"username": username, "action": `DENY ${oldRole}->${newRole}`});
    }

    const addDeleteUser = (username) => {
        addChange({"username": username, "action": "DELETE"});
    }

    const removeChange = (i) => {
        let array = [...changeList];
        array.splice(i, 1);
        setChangeList(array);
    }

    useEffect(() => {updateAccessList()}, []);
    useEffect(() => {updateAccessList(accessPage)}, [accessPage]);
    useEffect(() => {updateRequestList()}, []);
    useEffect(() => {updateRequestList(requestPage)}, [requestPage]);

    useEffect(() => {
        authFetch(`/admin/subscribed`, {
            method: "GET"
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            if (response.status === 401) {
                localStorage.removeItem("token");
                setAuth({});
            }
        }).then(json => {
            if (json) {
                setSubscribed(json.subscribed);
            }
    })}, []);

    useEffect(() => {setEmailError("")}, [email]);

    if (uploadPage) {
        return <Upload closeHandler={() => setUpload(false)} />
    }

    if (teacher !== "") {
        return <TeacherInterface
            successHandler={(state) => {
                if (!state) {
                    setTeacher("");
                }
            }}
            teacher={teacher}
        />
    }

    return <main className="page-shell">
        <div className="page-container">
        <div className="page-header">
            <ExitButton func={()=> {successHandler(false)}} />
            <div>
                <p className="panel-heading">Administration</p>
                <h1 className="page-heading">Admin dashboard</h1>
                <p className="page-subtitle">Manage users, access requests, invitations, and activity.</p>
            </div>
        </div>
        <div className="mb-4 flex justify-end">
            <Button text="Upload Excel" func={() => setUpload(true)} variant="secondary" />
        </div>
        <Selector 
            clickHandler={tab_index => setActiveTabIndex(tab_index)}
            tabsData={tabs} 
            active = {activeTabIndex}
        />

        {tabs[activeTabIndex] === 'User management' && <div className="management-grid">
                <section className="panel panel-body">
                    <div className="mb-4 flex items-center justify-between">
                        <h2 className="panel-heading">Users</h2>
                        <span className="status-pill">{users.length} on this page</span>
                    </div>
                        <Paginator
                            maxpage={accessPages} 
                            page={accessPage}
                            clickHandler={page => setAccessPage(page)}
                        />
                        {(users.length > 0) ? <div className="data-table mt-4">
                            <div className="data-row data-row-header">
                                <div>User</div>
                                <div>Role</div>
                                <div>Teacher view</div>
                                <div>Action</div>
                            </div>
                            {users.map(user => <div className="data-row" key={user.username}>
                                <div className="truncate font-bold text-cyan-950">{user.username}</div>
                                
                                <Dropdown
                                    options={options}
                                    onChange={option => addChangeAccess(user.username, user.role, option.label)}
                                    value={user.role}
                                />
                                
                                {user.role === "TEACHER" &&
                                    <Button text="Open dashboard" func={() => setTeacher(user.username)} variant="secondary" />
                                }
                                {user.role !== "TEACHER" && <span className="text-sm text-slate-400">Not applicable</span>}
                    
                                <Button text="Delete" func={() => addDeleteUser(user.username)} variant="danger"/>
                            </div>)}
                        </div> : <div className="empty-state">No users match the current page or filters.</div>}
                </section>
            
                <aside className="panel-stack">
                    {(changeList.length > 0) && <section className="notice-panel panel-stack">
                        <div className="flex items-center justify-between">
                            <h2 className="panel-heading">Pending changes</h2>
                            <span className="status-pill !bg-amber-100 !text-amber-800">{changeList.length}</span>
                        </div>
                            {changeList.map((change, i) => <div className="list-row" key={`${change.username}-${change.action}-${i}`}>
                                <div className="min-w-0">
                                    <div className="truncate font-bold">{change.username}</div>
                                    <div className="text-xs text-slate-500">{change.action}</div>
                                </div>
                                <Button text="Remove" func={() => removeChange(i)} variant="ghost"/>
                            </div>)}
                        <Button text="Apply changes" func={commit} />
                    </section>}
                    <section className="panel panel-body panel-stack">
                        <h2 className="panel-heading">Access requests</h2>
                            <form className="flex gap-2" onSubmit={searchRequests}>
                                <input
                                    className="form-field min-w-0 flex-1"
                                    type="text"
                                    placeholder="Search requests"
                                    onChange={e => setRequestSearch(e.target.value)}
                                />
                                <Button text="Search" type="submit" />
                            </form>
                    
                        {(requests.length > 0) ? <>
                            <Paginator
                                maxpage={requestPages} 
                                page={requestPage}
                                clickHandler={
                                    (page) => {setRequestPage(page);}
                                }
                            />
                            <div className="panel-stack">
                                {requests.map((request, index) => <div className="list-row" key={`${request.username}-${index}`}>
                                    <div className="min-w-0">
                                        <div className="truncate font-bold">{request.username}</div>
                                        <div className="text-xs text-slate-500">{request.newRole}</div>
                                    </div>
                                    {request.newRole.indexOf("/") === -1 &&
                                        <div className="flex flex-wrap gap-2">
                                            <Button text="Accept" func={() => addChangeAccess(request.username, request.oldRole, request.newRole)}/>
                                            <Button text="Deny" func={() => addDenyAccess(request.username, request.oldRole, request.newRole)} variant="secondary"/>
                                        </div>
                                    }
                                </div>)}
                            </div>
                        </> : <div className="empty-state">No access requests.</div>}

                        <label className="flex items-center gap-2 text-sm font-semibold text-slate-600">
                            <input
                                type="checkbox"
                                checked={subscribed}
                                onChange={handleCheck}
                            />
                            Subscribe to requests
                        </label>
                    </section>
                    
                    <form
                        className="panel panel-body panel-stack"
                        onSubmit={sendEmail}
                    >
                        <h2 className="panel-heading">Send an invitation</h2>
                        <input
                            className="form-field"
                            type="email"
                            placeholder="example@example.com"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                        {emailError && <div className="text-sm font-semibold text-cyan-800">{emailError}</div>}
                        <Button text="Send" type="submit" />
                    </form>
                </aside>
        </div>}

        {tabs[activeTabIndex] === 'User activities' && <div className="panel panel-body mt-4">
            <ActivitiesInterface />
        </div>}
        </div>
    </main>
}

export default AccessInterface;
